import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import {
    fetchAssignedProductsData,
    setSelectedBranch,
    setSelectedCategory,
    setSelectedCompany,
    resetFilters,
    selectBranches,
    selectSelectedBranch,
    selectSelectedCategory,
    selectSelectedCompany,
    selectFilteredCategories,
    selectFilteredCompanies,
    selectLoading
} from '../store/slices/viewAssignedProductSlice';
import './CategoryMaster.css';

const ViewAssignedProductHeader = () => {
    const dispatch = useDispatch();
    const branches = useSelector(selectBranches);
    const selectedBranch = useSelector(selectSelectedBranch);
    const selectedCategory = useSelector(selectSelectedCategory);
    const selectedCompany = useSelector(selectSelectedCompany);
    const filteredCategories = useSelector(selectFilteredCategories);
    const companyOptions = useSelector(selectFilteredCompanies);
    const loading = useSelector(selectLoading);

    useEffect(() => {
        dispatch(
            fetchAssignedProductsData({
                rolename: localStorage.getItem('role') || '',
                clientname: localStorage.getItem('clientid') || ''
            })
        );
    }, [dispatch]);

    const handleApplyFilters = () => {
        dispatch(
            fetchAssignedProductsData({
                rolename: localStorage.getItem('role') || '',
                clientname: localStorage.getItem('clientid') || ''
            })
        );
    };

    const handleReset = () => {
        dispatch(resetFilters());
        dispatch(
            fetchAssignedProductsData({
                rolename: localStorage.getItem('role') || '',
                clientname: localStorage.getItem('clientid') || ''
            })
        );
    };

    return (
        <>
            <div className="mb-4">
                <h2 className="text-3xl font-bold mb-2" style={{ color: 'var(--primary-color)' }}>
                    Special Products
                </h2>
                <p className="text-color-secondary">View and manage special product records filtered by branch, category and company</p>
            </div>

            <Card className="mb-4 bill-reports-filter-card">
                <div className="flex flex-wrap gap-4 align-items-end bill-reports-filter-row">
                    <div className="flex flex-column" style={{ flex: '1 1 200px', minWidth: '200px' }}>
                        <label className="mb-2 font-medium text-sm">Branch</label>
                        <Dropdown
                            value={selectedBranch}
                            options={branches}
                            onChange={(e) => dispatch(setSelectedBranch(e.value))}
                            optionLabel="branch_name"
                            placeholder="Select Branch"
                            className="w-full"
                            filter
                            showClear
                        />
                    </div>

                    <div className="flex flex-column" style={{ flex: '1 1 200px', minWidth: '200px' }}>
                        <label className="mb-2 font-medium text-sm">Category</label>
                        <Dropdown
                            value={selectedCategory}
                            options={filteredCategories}
                            onChange={(e) => dispatch(setSelectedCategory(e.value))}
                            optionLabel="name"
                            placeholder={selectedBranch ? 'Select Category' : 'Select Branch First'}
                            className="w-full"
                            filter
                            showClear
                            disabled={!selectedBranch}
                        />
                    </div>

                    <div className="flex flex-column" style={{ flex: '1 1 200px', minWidth: '200px' }}>
                        <label className="mb-2 font-medium text-sm">Company / Order Type</label>
                        <Dropdown
                            value={selectedCompany}
                            options={companyOptions}
                            onChange={(e) => dispatch(setSelectedCompany(e.value))}
                            optionLabel="company_name"
                            placeholder={selectedCategory ? 'Select Company / Order Type' : 'Select Category First'}
                            className="w-full"
                            filter
                            showClear
                            disabled={!selectedCategory}
                        />
                    </div>

                    <div className="flex gap-2" style={{ flex: '0 0 auto' }}>
                        <Button label="Apply Filters" icon="pi pi-check" className="p-button-primary" onClick={handleApplyFilters} disabled={loading} loading={loading} />
                        <Button label="Reset" icon="pi pi-refresh" className="p-button-secondary" onClick={handleReset} />
                    </div>
                </div>
            </Card>
        </>
    );
};

export default ViewAssignedProductHeader;
